import * as React from 'react';
import clsx from 'clsx';
import { getElementChildren } from '../../../utils';
import { Base } from '../../Base';
import { ListItem } from '../ListItem';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "UnorderedList-root_xOVC1",
  "item": "UnorderedList-item_5TBPh"
};
function UnorderedList({
  icon,
  iconTheme,
  className,
  children,
  ...extraProps
}) {
  let hasIcon = !!icon;
  const hasGap = typeof extraProps.gap === 'string';
  const elements = getElementChildren(children);
  const items = React.Children.map(elements, child => {
    if (!hasIcon) {
      hasIcon = typeof child.props.icon === 'string';
    }
    return /*#__PURE__*/React.cloneElement(child, {
      icon,
      iconTheme,
      ...child.props,
      className: clsx(child.props.className, styles.item)
    });
  });
  const theme = hasIcon ? {
    margin: 'none',
    padding: 'none',
    listStyleType: 'none'
  } : {
    margin: 'none',
    paddingLeft: 'small'
  };
  return /*#__PURE__*/_jsx(Base, {
    tagName: "ul",
    grid: hasGap,
    className: clsx(styles.root, className),
    ...theme,
    ...extraProps,
    children: items
  });
}
export { UnorderedList };